// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import axios from 'axios';
// import { useDispatch, useSelector } from 'react-redux';
// import Loader from '../../ApiCheck/Loader'; 
// import { baseUrl } from '../../ApiCheck/Constant';
// const Profile = () => {
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.user);

//   const [data, setData] = useState({
//     _id: "",
//     email: '',
//     firstname: '',
//     lastname: '',
//     phonenumber: '',
//   });

//   const [loading, setLoading] = useState(false);

//   const userdetails = async () => {
//     setLoading(true); 
//     try {
//       const response = await axios.post(`${baseUrl}/api/currentuser`, { _id: user._id });
//       setData(response.data.data);
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to fetch user details", { position: 'top-center', autoClose: 3000 });
//     } finally {
//       setLoading(false); 
//     }
//   };

//   useEffect(() => {
//     if (user._id) {
//       userdetails();
//     }
//   }, [user._id]);

//   const handleOnChange = (e) => {
//     const { name, value } = e.target;
//     setData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true); 
//     try {
//       await axios.put(`${baseUrl}/api/update/${data._id}`, data);
//       toast.success('Update Successful', { position: 'top-center', autoClose: 3000 });
//       navigate("/");
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Update failed", { position: 'top-center', autoClose: 3000 });
//     } finally {
//       setLoading(false); 
//     }
//   };

//   return (
//     <div className="container d-flex my-2 justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
//       {loading ? (
//         <Loader /> 
//       ) : (
//         <div className="card shadow-lg p-4" style={{ maxWidth: '500px', width: '100%' }}>
//           <div className="card-body">
//             <h4 className="card-title text-center mb-4">Update Profile</h4>
//             <form onSubmit={handleSubmit}>
//               <div className="form-group mb-3">
//                 <label htmlFor="firstname" className="form-label">First Name *</label>
//                 <input
//                   type="text"
//                   id="firstname"
//                   name="firstname"
//                   value={data.firstname}
//                   onChange={handleOnChange}
//                   required
//                   className="form-control"
//                   autoComplete="off"
//                 />
//               </div>
//               <div className="form-group mb-3">
//                 <label htmlFor="lastname" className="form-label">Last Name *</label>
//                 <input
//                   type="text"
//                   id="lastname"
//                   name="lastname"
//                   value={data.lastname}
//                   onChange={handleOnChange}
//                   required
//                   className="form-control"
//                   autoComplete="off"
//                 />
//               </div>
//               <div className="form-group mb-3">
//                 <label htmlFor="email" className="form-label">Email *</label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={data.email}
//                   onChange={handleOnChange}
//                   required
//                   className="form-control"
//                   autoComplete="off"
//                 />
//               </div>
//               <div className="form-group mb-3">
//                 <label htmlFor="phonenumber" className="form-label">Phone Number *</label>
//                 <input
//                   type="tel"
//                   id="phonenumber"
//                   name="phonenumber"
//                   value={data.phonenumber}
//                   onChange={handleOnChange}
//                   maxLength={10}
//                   minLength={10}
//                   pattern="[0-9+]*"
//                   required
//                   className="form-control"
//                   autoComplete="off"
//                 />
//               </div>
//               <div className="d-grid gap-2">
//                 <button type="submit" className="btn btn-dark">Update</button>
//               </div>
//               <div className="text-center mt-3">
//                 {user.role === 'ADMIN' ? (
//                   <Link to="/dashboard" className="text-secondary">Back to Dashboard</Link>
//                 ) : (
//                   <Link to="/" className="text-secondary">Back to Home</Link>
//                 )}
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Profile;
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Loader from '../../ApiCheck/Loader'; 
import { baseUrl } from '../../ApiCheck/Constant';
import { Button, Form, Card } from 'react-bootstrap';

const Profile = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
console.log("user", user)
  const [data, setData] = useState({
    _id: '',
    email: '',
    firstname: '',
    lastname: '',
    phonenumber: '',
  });

  const [addresses, setAddresses] = useState([]);
  const [newAddress, setNewAddress] = useState({
    city: '',
    state: '',
    country: '',
    pinCode: '',
    addressLine1: '',
    addressLine2: '',
  });

  const [loading, setLoading] = useState(false);
  const [editModeId, setEditModeId] = useState(null);
  const [showNewForm, setShowNewForm] = useState(false);

  const fetchUser = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${baseUrl}/api/currentuser`, { _id: user._id });
      setData(response.data.data);
    } catch (error) {
      toast.error("Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const fetchAddresses = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/getaddress/${user._id}`);
      setAddresses(response.data.data);
    } catch (error) {
      toast.error("Failed to load addresses");
    }
  };

  useEffect(() => {
    if (user._id) {
      fetchUser();
      fetchAddresses();
    }
  }, [user._id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`${baseUrl}/api/update/${data._id}`, data);
      toast.success("Profile updated");
      navigate('/');
    } catch (error) {
      toast.error("Update failed");
    } finally {
      setLoading(false);
    }
  };

  const handleAddressSave = async () => {
    const { city, state, country, pinCode, addressLine1, addressLine2 } = newAddress;
    if (!city || !state || !country || !pinCode || !addressLine1 || !addressLine2) {
      toast.error("Please fill all fields");
      return;
    }
    try {
      const res = await axios.post(`${baseUrl}/api/address`, {
        ...newAddress,
        userId: user._id,
      });
      setAddresses([...addresses, res.data.data]);
      setNewAddress({
        city: '',
        state: '',
        country: '',
        pinCode: '',
        addressLine1: '',
        addressLine2: '',
      });
      setShowNewForm(false);
    } catch (err) {
      toast.error("Failed to save address");
    }
  };

  const handleAddressUpdate = async (addr) => {
    try {
      const res = await axios.put(`${baseUrl}/api/address/${addr._id}`, addr);
      const updated = addresses.map((a) => (a._id === addr._id ? res.data.data : a));
      setAddresses(updated);
      setEditModeId(null);
      toast.success("Address updated");
    } catch {
      toast.error("Failed to update address");
    }
  };

  const handleAddressDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl}/api/address/${id}`);
      setAddresses(addresses.filter((a) => a._id !== id));
      toast.success("Address deleted");
    } catch {
      toast.error("Failed to delete address");
    }
  };

  return (
    <div className="container my-4 w-50">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Card className="mb-4 p-4 shadow-sm">
            <h4>Update Profile</h4>
            <form onSubmit={handleProfileUpdate}>
              <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" name="firstname" value={data.firstname} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" name="lastname" value={data.lastname} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" name="email" value={data.email} onChange={handleChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control type="tel" name="phonenumber" value={data.phonenumber} onChange={handleChange} required maxLength={10} />
              </Form.Group>
              <Button type="submit" variant="dark">Update</Button>
            </form>
          </Card>
{user && user.role != "ADMIN" &&  (
  <>

          <Card className="p-4 shadow-sm">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4>Delivery Addresses</h4>
              <Button onClick={() => setShowNewForm(!showNewForm)}>{showNewForm ? 'Cancel' : 'Add New'}</Button>
            </div>

            {addresses.map((addr) => (
              <Card key={addr._id} className="p-3 mb-3">
                {editModeId === addr._id ? (
                  <>
                    {['addressLine1', 'addressLine2', 'city', 'state', 'pinCode', 'country'].map((field) => (
                      <Form.Control
                        className="mb-2"
                        key={field}
                        placeholder={field}
                        value={addr[field]}
                        onChange={(e) => setAddresses(addresses.map(a => a._id === addr._id ? { ...a, [field]: e.target.value } : a))}
                      />
                    ))}
                    <div className="d-flex gap-2">
                      <Button size="sm" variant="dark" onClick={() => handleAddressUpdate(addr)}>Save</Button>
                      <Button size="sm" variant="secondary" onClick={() => setEditModeId(null)}>Cancel</Button>
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      {addr.addressLine1}, {addr.addressLine2}, {addr.city}, {addr.state}, {addr.pinCode}, {addr.country}
                    </div>
                    <div className="mt-2 d-flex gap-2">
                      <Button size="sm" variant="dark" onClick={() => setEditModeId(addr._id)}>Edit</Button>
                      <Button size="sm" variant="danger" onClick={() => handleAddressDelete(addr._id)}>Delete</Button>
                    </div>
                  </>
                )}
              </Card>
            ))}

            {showNewForm && (
              <Card className="p-3 mt-3">
                {['addressLine1', 'addressLine2', 'city', 'state', 'pinCode', 'country'].map((field) => (
                  <Form.Group className="mb-2" key={field}>
                    <Form.Label>{field}</Form.Label>
                    <Form.Control
                      type="text"
                      value={newAddress[field]}
                      onChange={(e) => setNewAddress({ ...newAddress, [field]: e.target.value })}
                    />
                  </Form.Group>
                ))}
                <Button onClick={handleAddressSave}>Save Address</Button>
              </Card>
            )}
          </Card>

          <div className="text-center mt-4">
            <Link to={user.role === 'ADMIN' ? '/dashboard' : '/'} className="text-secondary">
              Back to {user.role === 'ADMIN' ? 'Dashboard' : 'Home'}
            </Link>
          </div>
          </>
)}
        </>
      )}
    </div>
  );
};

export default Profile;
